export default __webpack_public_path__ + "alberta-electrostimulation.5dfb65fb2976c0f195c1.svg";